import { useQuery } from '@tanstack/vue-query'
import { apiClient } from '@/apis/instances/api-client'
import { checkApiResponse } from '@/apis/instances/check-api-response'
import { ApiServicesettingElFindOneParams } from '@/apis/swaggers/v2/v2-swagger'
import { QUERY_KEY } from '@/apis/swaggers/swagger-docs'
import { QueryComposableParams } from '@/types/query-options'
import { resolveMaybeGetter } from '@/util/resolve-maybe-getter'

type QueryParams = QueryComposableParams<ApiServicesettingElFindOneParams, unknown>

const fetchServiceSettingFindOne = async (params: ApiServicesettingElFindOneParams) => {
  const { data } = await apiClient.v2.apiServicesettingElFindOne(params);
  return checkApiResponse(data);
}

export const v2ServiceSettingKeys = {
  all: [QUERY_KEY.v2apiServicesettingElFindOne] as const,
  detail: (params: ApiServicesettingElFindOneParams) => [...v2ServiceSettingKeys.all, params] as const,
}

/** 명령형(await) 호출용 쿼리 정의 — 부트스트랩처럼 순차 흐름이 필요한 곳에서
 * `queryClient.fetchQuery(v2ServiceSettingFindOneQueryOptions(params))` 로 사용한다 (캐시 경유는 동일) */
export const v2ServiceSettingFindOneQueryOptions = (params: ApiServicesettingElFindOneParams) => ({
  queryKey: v2ServiceSettingKeys.detail(params),
  queryFn: () => fetchServiceSettingFindOne(params),
})

export const useV2ServiceSettingFindOneQuery = ({ params, options }: QueryParams) => {
  return useQuery(() => ({
    queryKey: v2ServiceSettingKeys.detail(resolveMaybeGetter(params)),
    queryFn: () => fetchServiceSettingFindOne(resolveMaybeGetter(params)),
    ...resolveMaybeGetter(options ?? {}),
  }))
}
